import React, { useMemo } from "react";
import styled from "styled-components";

const ActionIndicator = styled.div`
  flex: none;
  /** for debug */
  // width: 25px;
  // height: 25px;
  // background-color: red;
`;

const ActionIndicatorContainer = () => {
  return useMemo(() => {
    return <ActionIndicator id="uc-action-indicator-container" />;
  }, []);
};

export default ActionIndicatorContainer;
